import { doc, serverTimestamp, setDoc } from 'firebase/firestore';

import type { SceneStatus } from '../../types/scene';

export const sanitizeSceneName = (value: string): string => {
  const trimmed = value.trim();
  const bounded = trimmed.slice(0, 60);
  return bounded.length >= 2 ? bounded : 'Untitled Scene';
};

export const sanitizeSceneDescription = (value: string): string => value.trim().slice(0, 500);

export const sanitizeTags = (value: string[]): string[] =>
  value
    .map((tag) => tag.trim().toLowerCase())
    .filter((tag) => tag.length >= 2 && tag.length <= 30)
    .filter((tag, index, list) => list.indexOf(tag) === index)
    .slice(0, 10);

export const normalizeWritableStatus = (value: SceneStatus): SceneStatus =>
  value === 'published' || value === 'featured' || value === 'archived' ? value : 'draft';

export const seedNewSceneForStorageUploads = async ({
  levelDesignId,
  name,
  ownerDisplayName,
  tags,
  targetRef,
  userId,
}: {
  levelDesignId: string;
  name: string;
  ownerDisplayName: string;
  tags: string[];
  targetRef: ReturnType<typeof doc>;
  userId: string;
}): Promise<void> => {
  await setDoc(
    targetRef,
    {
      id: targetRef.id,
      ownerId: userId,
      ownerDisplayName: ownerDisplayName.trim() || 'Explorer',
      name: sanitizeSceneName(name),
      status: 'draft',
      tags: sanitizeTags(tags),
      levelDesignId,
      npcPlacements: [],
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    },
    { merge: true },
  );
};
